import { ButtonProps } from "antd";
import styled from "styled-components";

import { Badge, Button } from "antd";
export interface IIconButtonProps extends ButtonProps {
    hasLeftBorder?: boolean;
    hasRightBorder?: boolean;
    count?: number;
    isMood?: boolean;
    onClick?: () => void;
}

const IconButtonWrapper = styled.div`
    height: 100%;
    .ant-badge {
        height: 100%;
    }
`;

const EbuhBadge = styled(Badge)`
    display: flex;
    align-items: center;
`;

const IconButtonComponent = styled(Button)<IIconButtonProps>`
    padding: 0 10px;
    margin: 0;
    height: 100%;
    border-radius: 0;
    height: 32px;
    width: 32px;
    ${({ hasLeftBorder }) => hasLeftBorder && "border-left: 1px solid #C7C7C7;"}
    ${({ hasRightBorder }) => hasRightBorder && "border-right: 1px solid #C7C7C7;"}

    &.ant-btn.ant-btn-icon-only {
        width: auto;
        padding: 7px;
        color: var(--primary-text);

        &:hover {
            color: var(--primary-text);
        }
    }
`;

const ButtonIcon = ({ count = 0, ...props }: IIconButtonProps) => {
    return (
        <IconButtonWrapper>
            <EbuhBadge color="var(--tool-button-text)" count={count} offset={[-15, 15]}>
                <IconButtonComponent {...props}>{props.children}</IconButtonComponent>
            </EbuhBadge>
        </IconButtonWrapper>
    );
};

export default ButtonIcon;
